import { FC, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppContext } from '../App';
import { FileControl } from '../components/FileControl';
import { UPLOAD_URL } from '../types/API_URLs';

export const FileUploader: FC = () => {
    const { accountNumberReq, setAccountNumberReq } = useContext(AppContext);
    //@ts-ignore:next-line
    const [fileState, setFileState] = useState(File[0]);
    //@ts-ignore:next-line
    const [fileStateTwo, setFileStateTwo] = useState(File[0]);
    //@ts-ignore:next-line
    const [fileStateThree, setFileStateThree] = useState(File[0]);
    //@ts-ignore:next-line
    const [fileStateFour, setFileStateFour] = useState(File[0]);
    //@ts-ignore:next-line
    const [fileStateFive, setFileStateFive] = useState(File[0]);

    const [showFileTwo, setShowFileTwo] = useState(false);
    const [showFileThree, setShowFileThree] = useState(false);
    const [showFileFour, setShowFileFour] = useState(false);
    const [showFileFive, setShowFileFive] = useState(false);
    const [showMoreFileOption, setshowMoreFileOption] = useState(true);
    const [maxFiles, setMaxFiles] = useState(5);
    const [uploadState, setUploadState] = useState('none');
    const navigate = useNavigate();

    useEffect(() => {
        !accountNumberReq.uuid && navigate('/');
    });

    const showAddFiles = () => {
        var noOfFiles = 0;

        (!showFileTwo && fileState?.length > 0 && fileState?.length < 5) ? setShowFileTwo(true) : setshowMoreFileOption(false);

        fileState && (noOfFiles = fileState.length);
        fileStateTwo?.length > 0 && (noOfFiles += fileStateTwo.length);
        fileState && setMaxFiles(5 - noOfFiles);

        (!showFileThree && fileStateTwo?.length > 0 && noOfFiles < 5) ? setShowFileThree(true) : setshowMoreFileOption(false);

        fileStateThree?.length > 0 && (noOfFiles += fileStateThree.length);
        fileStateTwo && setMaxFiles(5 - noOfFiles);

        (!showFileFour && fileStateThree?.length > 0 && noOfFiles < 5) ?
            setShowFileFour(true) : setshowMoreFileOption(false);

        fileStateFour?.length > 0 && (noOfFiles += fileStateFour.length);
        fileStateThree && setMaxFiles(5 - noOfFiles);

        if (!showFileFive && fileStateFour?.length > 0 && noOfFiles < 5) {

            setMaxFiles(5 - noOfFiles);
            setShowFileFive(true);
            setshowMoreFileOption(false);
        }
    }


    const resetAllowedMaxFiles = () => {
        var noOfFiles = 0;

        fileState && (noOfFiles = fileState.length);
        fileStateTwo?.length > 0 && (noOfFiles += fileStateTwo.length);
        fileState && setMaxFiles(5 - noOfFiles);

        fileStateThree?.length > 0 && (noOfFiles += fileStateThree.length);
        fileStateTwo && setMaxFiles(5 - noOfFiles);

        fileStateFour?.length > 0 && (noOfFiles += fileStateFour.length);
        fileStateThree && setMaxFiles(5 - noOfFiles);

        fileStateFour && setMaxFiles(5 - noOfFiles);

        if (noOfFiles < 5 && !showFileFive) {
            setshowMoreFileOption(true);
        }

    }

    const uploadData = () => {
        setUploadState('loading');

        var data = new FormData()

        for (const file of fileState) {
            data.values?.length < 5 && data.append('files[]', file, file.name);
        }
        if (fileStateTwo?.length > 0) {
            for (const file of fileStateTwo) {
                data.values?.length < 5 && data.append('files[]', file, file.name);
            }
        }
        if (fileStateThree?.length > 0) {
            for (const file of fileStateThree) {
                data.values?.length < 5 && data.append('files[]', file, file.name);
            }
        }
        if (fileStateFour?.length > 0) {
            for (const file of fileStateFour) {
                data.values?.length < 5 && data.append('files[]', file, file.name);
            }
        }
        if (fileStateFive?.length > 0) {
            for (const file of fileStateFive) {
                data.append('files[]', file, file.name);
            }
        }

        data.append('postcode', accountNumberReq.postcode);
        data.append('accountNumber', accountNumberReq.accountNumber);
        data.append('uuid', accountNumberReq.uuid);
        data.append('lastName', accountNumberReq.lastName);
        data.append('dateOfBirth', accountNumberReq.dateOfBirth);
        data.append('uploadType', accountNumberReq.fileTye);
        data.append('creditorDocType', accountNumberReq.creditorDocType);
        data.append('incomeDocType', accountNumberReq.incomeDocType);
        data.append('token', accountNumberReq.token);

        fetch(UPLOAD_URL, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: data,
        }).then((resp) => {
            if (resp && resp.ok) {
                // reset relevant form state
                setAccountNumberReq({ ...accountNumberReq, fileTye: '', creditorDocType: '', incomeDocType: '' })
                navigate('/complete');
            } else {
                setUploadState('error');
            }
        }
        ).catch(() => {
            setUploadState('error');
        }
        );
    }

    const filesStaged = fileState?.length > 0 || fileStateTwo?.length > 0 || fileStateThree?.length > 0 || fileStateFour?.length > 0 || fileStateFive?.length > 0;

    return (
        <div className="page">
            <div className="container">

                <h1 className="page__title u-m__b--l">Upload your files </h1>

                <div className="u-m__b--l">
                    <h2>We accept upto 5 files in PDF, JPG or PNG format upto 20mb.</h2>
                </div>
                <div id="files">
                    <FileControl uploadState={uploadState} fileState={fileState} setFileState={setFileState} resetAllowedMaxFiles={resetAllowedMaxFiles} data-selector="file-1" setShowFileControl={() => { }} maxFiles={maxFiles} />

                    {showFileTwo && <FileControl uploadState={uploadState} fileState={fileStateTwo} setFileState={setFileStateTwo} resetAllowedMaxFiles={resetAllowedMaxFiles} setShowFileControl={setShowFileTwo} data-selector="file-2" maxFiles={maxFiles} />}
                    {showFileThree && <FileControl uploadState={uploadState} fileState={fileStateThree} setFileState={setFileStateThree} resetAllowedMaxFiles={resetAllowedMaxFiles} setShowFileControl={setShowFileThree} data-selector="file-3" maxFiles={maxFiles} />}
                    {showFileFour && <FileControl uploadState={uploadState} fileState={fileStateFour} setFileState={setFileStateFour} resetAllowedMaxFiles={resetAllowedMaxFiles} setShowFileControl={setShowFileFour} data-selector="file-4" maxFiles={maxFiles} />}
                    {showFileFive && <FileControl uploadState={uploadState} fileState={fileStateFive} setFileState={setFileStateFive} resetAllowedMaxFiles={resetAllowedMaxFiles} setShowFileControl={setShowFileFive} data-selector="file-5" maxFiles={maxFiles} />}

                </div>
                {uploadState === 'none' && filesStaged && showMoreFileOption && <button onClick={showAddFiles} className="btn u-m__t--l">Add more</button>}
                {uploadState === 'none' && filesStaged && <button onClick={uploadData} className="btn u-m__t--l">Submit</button>}

            </div>
        </div>
    );
}



